export const createAsyncRequestActions = (category, actionBaseName) => {
  return {
    start: `luft/${category}/${actionBaseName}_START`,
    finish: `luft/${category}/${actionBaseName}_FINISH`,
  };
};

export const createActionString = (category, actionName) =>
  `luft/${category}/${actionName}`;

export const createAsyncCreators = actions => {
  return {
    start: (payload, error = false, meta = null) => ({
      type: actions.start,
      payload,
      meta,
      error,
    }),
    finish: (payload, error = false, meta = null) => ({
      type: actions.finish,
      payload,
      meta,
      error,
    }),
  };
};
